<template>
  <v-menu v-model="menuStatus" :close-on-content-click="true" open-on-click>
    <template #activator="{ props }">
      <v-badge v-if="downloadsInProgress" color="error" :content="activeDownloads.length" :model-value="downloadsInProgress" offset-x="4" offset-y="4" max="99">
        <v-btn variant="plain" :icon="mdiFileDownload" v-bind="props" density="comfortable" />
      </v-badge>
    </template>
    <v-list>
      <headbar-downloads-menu-item
        v-for="activeDownload in activeDownloads"
        :key="activeDownload.id"
        :active-download="activeDownload"
        @clear="downloadsStore.clearActiveDownload"
      />
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { mdiFileDownload } from '@mdi/js'

const menuStatus = ref(false)
const downloadsStore = useDownloadsStore()
const { activeDownloads } = storeToRefs(downloadsStore)
const downloadsInProgress = computed(() => activeDownloads.value.length > 0)

whenever(() => activeDownloads.value.length === 0, () => {
  menuStatus.value = false
})
</script>

<style lang="css">
</style>
